module.exports = __webpack_public_path__ + "img/pstk.b3ee46e2.png";